import { StorePurchaseHistoryFragment } from '@/clients/utoniq-core/schema'

/**
 * ストア購入履歴のアイテムの内容をコレクション単位でグルーピングする
 * @param items ストア購入履歴のアイテムフィールド
 * @returns
 */

export const groupOrderItemsByCollection = (
  items: StorePurchaseHistoryFragment['items'] | undefined
) => {
  if (!items) return []

  const { collections, nullCollectionItems } = items.reduce(
    (acc, item) => {
      const collection = item.item.collection
        ? {
            id: item.item.collection.id,
            title: item.item.collection.title,
          }
        : null

      if (collection) {
        const existingCollection = acc.collections.find(
          it => it.collection?.id === collection.id
        )
        if (!existingCollection) {
          acc.collections.push({
            collection,
            items: [item],
          })
        } else {
          existingCollection.items.push(item)
        }
      } else {
        acc.nullCollectionItems.push(item)
      }

      return acc
    },
    {
      collections: [] as {
        collection: { id: string; title: string } | null
        items: StorePurchaseHistoryFragment['items']
      }[],
      nullCollectionItems: [] as StorePurchaseHistoryFragment['items'],
    }
  )

  // コレクションに関連づいていないアイテムは collection: null でグルーピングする
  if (nullCollectionItems.length) {
    collections.push({
      collection: null,
      items: nullCollectionItems,
    })
  }

  return collections
}
